import { Box, Chip, LinearProgress, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { isEmpty } from '../../../../utils/isEmpty';

type Props = {
    value: string;
    error: boolean;
};

const StatusColumn = ({ value, error }: Props) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1, color: error && isEmpty(value) ? 'red' : 'white' }}>
                    {error && isEmpty(value) && (
                        <>
                            <ErrorIcon color="error" sx={{ float: 'left', mr: 1 }} />{' '}
                            <Typography variant="subtitle1" sx={{ float: 'left' }}>
                                Missing Data
                            </Typography>
                        </>
                    )}
                    {!isEmpty(value) && value}
                </Box>
            </Box>
        </Box>
    );
};

export { StatusColumn };
export default StatusColumn;
